import React, { useState } from "react";
import { Createpost } from "../api/axios";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/userContext";

const Create = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const user = useUser();
  // const [name, setName] = useState("");
  const [githubLink, setGithubLink] = useState("");
  const [coverImage, setImage] = useState("");
  const [problem, setProblem] = useState("");
  const [technologies, setTechnologies] = useState("");
  const createProject = () => {
    Createpost({
      name,
      githubLink,
      coverImage,
      setImage,
      problem,
      usn: user.user.usn,
      technologies: technologies.split(""),
      access: user.user.token,
    })
      .then((res) => {
        navigate("/");
      })
      .catch((e) => {});
  };
  return (
    <div className="flex-1">
      <>
        <div className="imgcontainer">
          <img
            src="https://img.freepik.com/premium-vector/game-developers-team-office-geeks-coworking-digital-entertainment-production-coders-designers-screenwriters-brainstorming-teamwork-meeting-vector-isolated-concept_176411-5097.jpg?w=2000"
            alt="topimg"
            className="topimg"
          />
        </div>
        <div className="form">
          <h2>Tell us more about your project</h2>
          <div className="innercontainer">
            <h3>Project Name</h3>
            <p className="gray">What are you calling it? </p>
            <input
              type="text"
              className="input"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <div className="innercontainer">
            <h3>The Problem It Solves</h3>
            <p className="gray">Describe what can people use</p>
            <input
              type="text"
              className="input"
              value={problem}
              onChange={(e) => {
                setProblem(e.target.value);
              }}
            />
          </div>
          <div className="innercontainer">
            <h3>Technologies I Used</h3>
            <p className="gray">
              What are you calling it?(separated by commas){" "}
            </p>
            <input
              type="text"
              className="input"
              value={technologies}
              onChange={(e) => {
                setTechnologies(e.target.value);
              }}
            />
          </div>
          <div className="innercontainer">
            <h3>GitHub Link</h3>
            <p className="gray">Please provide us with your GitHub Link</p>
            <input
              type="text"
              className="input"
              value={githubLink}
              onChange={(e) => {
                setGithubLink(e.target.value);
              }}
            />
          </div>
          <div className="innercontainer">
            <h3>Cover Image Link</h3>
            <p className="gray">Please provide us with your image Link</p>
            <input
              type="text"
              className="input"
              value={coverImage}
              onChange={(e) => {
                setImage(e.target.value);
              }}
            />
          </div>
          <div className="addprojwrapper">
            {" "}
            <div className="addproj" onClick={() => createProject()}>
              Add Project (10 points)
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Create;
